<template>
  <div class="data-page">
    <top-bar :topbarList="dataTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { dataIndexMixins } from "@/mixins/dataIndexMixins";

export default {
  mixins: [dataIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.data-page {
  height: 100%;
}
</style>
